const list = ['D847','K749','ME51','NI86','ON02','WH16','WH17','WH18','WH19','WH20','WH21','WH22','WH23','WH24','WH25','WH26','WH27','WH28','X918','OC79','PK87','QA22'];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
}